import React, { useState, useEffect } from 'react';
import Reaptcha from 'reaptcha';
import api from '~/services/api';
import Toastify from "~/components/Toastify";
import ReactTooltip from "react-tooltip";
import { TextArea, InputRadio, ButtonPadraoPrimary } from '~/styles/CommonStyles';
import { Container, ContainerDisclaimer, Disclaimer, ContainerPerguntas, Pergunta, Estrelas } from './stylesAvaliacao';

import getUrlParameter from '~/helpers/getURLencode';

import { useRecoilState } from 'recoil';
import { mensagemConformidadeLGPD } from '../../atoms/conformidade';

function Avaliacao ( { location } ) {
    const params = new URLSearchParams( location.search );
    const _CHAVE = params.get( 'chave' );
    const [ recaptchaToken, setRecaptchaToken ] = useState( null );
    const [ conformidadeMensagem, setConformidadeMensagem ] = useRecoilState( mensagemConformidadeLGPD );

    const [ pesquisa, setPesquisa ] = useState( {
        localizacao: 0,
        infraestrutura: 0,
        atendimento: 0,
        atendimentoespecial: 0,
        pontualidade: 0,
        qualidadeinfo: 0,
        custobeneficio: 0,
        avaliacaogeral: 0,
        indicaria: 0,
        comentarios: "",
    } );

    useEffect( () => {
        if ( !_CHAVE )
            return Toastify.error( 'Chave inexistente, por favor clique novamente no link enviado para o medico ou solicite um novo email com link.' );
        setConformidadeMensagem( { popUpOpen: true } );
    }, [] );

    useEffect( () => {
        console.log( pesquisa.indicaria );
    }, [ pesquisa ] );


    async function salvaPesquisa () {
        try {
            if ( !_CHAVE )
                return Toastify.error( 'Erro, falta de chave. Por favor abra o link enviado pelo médico.' );

            if ( !recaptchaToken )
                return Toastify.warning( 'Por favor, faça a verificação.' );

            let { data } = await api.post( `/apoio/salvaPesquisadeQualidade`, { ...pesquisa, Chave: _CHAVE, responsecaptcha: recaptchaToken } );

            if ( data == 'Success' ) {
                return Toastify.success( 'Avaliação enviada por sucesso.' );
            } else {

                return Toastify.warning( 'Não foi possivel salvar sua avaliação.' );
            }

        } catch ( error ) {
            console.log( error );
            return Promise.reject( error );;
        }
    };

    return (
        <Container>
            <h1 style={ { display: 'flex', justifyContent: "center", flex: 'auto 1 0' } }>Pesquisa de Qualidade do Atendimento</h1>
            <ContainerDisclaimer>
                <Disclaimer>
                    Essa pesquisa busca fornecer informações para melhorar a qualidade do nosso atendimento.
                </Disclaimer>
                <Disclaimer>
                    Leia cada item da avaliação abaixo e clique sobre a quantidade de "estrelas" correspondente a nota que quer dar para esse determinado quesito (de 1 a 5, onde 1 significa RUIM e 5 significa EXCELENTE).
                </Disclaimer>
                <Disclaimer>
                    Ao final do processo, clique em enviar.
                </Disclaimer>
            </ContainerDisclaimer>
            <ContainerPerguntas>
                <Pergunta>
                    <h2> Localização </h2>
                    <article>
                        <h3>O local de atendimento é bem localizado? Tem fácil acesso?</h3>
                        <div>
                            <Estrelas valor={ 1 } valoratual={ pesquisa.localizacao } onClick={ () => setPesquisa( { ...pesquisa, localizacao: 1 } ) } />
                            <Estrelas valor={ 2 } valoratual={ pesquisa.localizacao } onClick={ () => setPesquisa( { ...pesquisa, localizacao: 2 } ) } />
                            <Estrelas valor={ 3 } valoratual={ pesquisa.localizacao } onClick={ () => setPesquisa( { ...pesquisa, localizacao: 3 } ) } />
                            <Estrelas valor={ 4 } valoratual={ pesquisa.localizacao } onClick={ () => setPesquisa( { ...pesquisa, localizacao: 4 } ) } />
                            <Estrelas valor={ 5 } valoratual={ pesquisa.localizacao } onClick={ () => setPesquisa( { ...pesquisa, localizacao: 5 } ) } />
                        </div>
                    </article>
                </Pergunta>
                <Pergunta>
                    <h2> Infraestrutura </h2>
                    <article>
                        <h3>O local de atendimento estava organizado e em ordem?</h3>
                        <div>
                            <Estrelas valor={ 1 } valoratual={ pesquisa.infraestrutura } onClick={ () => setPesquisa( { ...pesquisa, infraestrutura: 1 } ) } />
                            <Estrelas valor={ 2 } valoratual={ pesquisa.infraestrutura } onClick={ () => setPesquisa( { ...pesquisa, infraestrutura: 2 } ) } />
                            <Estrelas valor={ 3 } valoratual={ pesquisa.infraestrutura } onClick={ () => setPesquisa( { ...pesquisa, infraestrutura: 3 } ) } />
                            <Estrelas valor={ 4 } valoratual={ pesquisa.infraestrutura } onClick={ () => setPesquisa( { ...pesquisa, infraestrutura: 4 } ) } />
                            <Estrelas valor={ 5 } valoratual={ pesquisa.infraestrutura } onClick={ () => setPesquisa( { ...pesquisa, infraestrutura: 5 } ) } />
                        </div>
                    </article>
                </Pergunta>
                <Pergunta>
                    <h2> Atendimento </h2>
                    <article>
                        <h3>Você foi bem atendido pelas secretárias, recepcionistas e demais funcionários?</h3>
                        <div>
                            <Estrelas valor={ 1 } valoratual={ pesquisa.atendimento } onClick={ () => setPesquisa( { ...pesquisa, atendimento: 1 } ) } />
                            <Estrelas valor={ 2 } valoratual={ pesquisa.atendimento } onClick={ () => setPesquisa( { ...pesquisa, atendimento: 2 } ) } />
                            <Estrelas valor={ 3 } valoratual={ pesquisa.atendimento } onClick={ () => setPesquisa( { ...pesquisa, atendimento: 3 } ) } />
                            <Estrelas valor={ 4 } valoratual={ pesquisa.atendimento } onClick={ () => setPesquisa( { ...pesquisa, atendimento: 4 } ) } />
                            <Estrelas valor={ 5 } valoratual={ pesquisa.atendimento } onClick={ () => setPesquisa( { ...pesquisa, atendimento: 5 } ) } />
                        </div>
                    </article>
                </Pergunta>
                <Pergunta>
                    <h2> Atendimento clínico </h2>
                    <article>
                        <h3>Você foi bem atendido pelos médicos e demais funcionários do corpo clínico?</h3>
                        <div>
                            <Estrelas valor={ 1 } valoratual={ pesquisa.atendimentoespecial } onClick={ () => setPesquisa( { ...pesquisa, atendimentoespecial: 1 } ) } />
                            <Estrelas valor={ 2 } valoratual={ pesquisa.atendimentoespecial } onClick={ () => setPesquisa( { ...pesquisa, atendimentoespecial: 2 } ) } />
                            <Estrelas valor={ 3 } valoratual={ pesquisa.atendimentoespecial } onClick={ () => setPesquisa( { ...pesquisa, atendimentoespecial: 3 } ) } />
                            <Estrelas valor={ 4 } valoratual={ pesquisa.atendimentoespecial } onClick={ () => setPesquisa( { ...pesquisa, atendimentoespecial: 4 } ) } />
                            <Estrelas valor={ 5 } valoratual={ pesquisa.atendimentoespecial } onClick={ () => setPesquisa( { ...pesquisa, atendimentoespecial: 5 } ) } />
                        </div>
                    </article>
                </Pergunta>
                <Pergunta>
                    <h2> Pontualidade </h2>
                    <article>
                        <h3>Você foi atendido no horário marcado?</h3>
                        <div>
                            <Estrelas valor={ 1 } valoratual={ pesquisa.pontualidade } onClick={ () => setPesquisa( { ...pesquisa, pontualidade: 1 } ) } />
                            <Estrelas valor={ 2 } valoratual={ pesquisa.pontualidade } onClick={ () => setPesquisa( { ...pesquisa, pontualidade: 2 } ) } />
                            <Estrelas valor={ 3 } valoratual={ pesquisa.pontualidade } onClick={ () => setPesquisa( { ...pesquisa, pontualidade: 3 } ) } />
                            <Estrelas valor={ 4 } valoratual={ pesquisa.pontualidade } onClick={ () => setPesquisa( { ...pesquisa, pontualidade: 4 } ) } />
                            <Estrelas valor={ 5 } valoratual={ pesquisa.pontualidade } onClick={ () => setPesquisa( { ...pesquisa, pontualidade: 5 } ) } />
                        </div>
                    </article>
                </Pergunta>
                <Pergunta>
                    <h2> Informações sobre o tratamento </h2>
                    <article>
                        <h3>As informações sobre o tratamento proposto foram claras e bem explicadas?</h3>
                        <div>
                            <Estrelas valor={ 1 } valoratual={ pesquisa.qualidadeinfo } onClick={ () => setPesquisa( { ...pesquisa, qualidadeinfo: 1 } ) } />
                            <Estrelas valor={ 2 } valoratual={ pesquisa.qualidadeinfo } onClick={ () => setPesquisa( { ...pesquisa, qualidadeinfo: 2 } ) } />
                            <Estrelas valor={ 3 } valoratual={ pesquisa.qualidadeinfo } onClick={ () => setPesquisa( { ...pesquisa, qualidadeinfo: 3 } ) } />
                            <Estrelas valor={ 4 } valoratual={ pesquisa.qualidadeinfo } onClick={ () => setPesquisa( { ...pesquisa, qualidadeinfo: 4 } ) } />
                            <Estrelas valor={ 5 } valoratual={ pesquisa.qualidadeinfo } onClick={ () => setPesquisa( { ...pesquisa, qualidadeinfo: 5 } ) } />
                        </div>
                    </article>
                </Pergunta>
                <Pergunta>
                    <h2> Custo x benefício </h2>
                    <article>
                        <h3>Como você avalia o custo x benefício do atendimento recebido?</h3>
                        <div>
                            <Estrelas valor={ 1 } valoratual={ pesquisa.custobeneficio } onClick={ () => setPesquisa( { ...pesquisa, custobeneficio: 1 } ) } />
                            <Estrelas valor={ 2 } valoratual={ pesquisa.custobeneficio } onClick={ () => setPesquisa( { ...pesquisa, custobeneficio: 2 } ) } />
                            <Estrelas valor={ 3 } valoratual={ pesquisa.custobeneficio } onClick={ () => setPesquisa( { ...pesquisa, custobeneficio: 3 } ) } />
                            <Estrelas valor={ 4 } valoratual={ pesquisa.custobeneficio } onClick={ () => setPesquisa( { ...pesquisa, custobeneficio: 4 } ) } />
                            <Estrelas valor={ 5 } valoratual={ pesquisa.custobeneficio } onClick={ () => setPesquisa( { ...pesquisa, custobeneficio: 5 } ) } />
                        </div>
                    </article>
                </Pergunta>
                <Pergunta>
                    <h2> Avaliação geral </h2>
                    <article>
                        <h3>Qual a sua avaliação geral da nossa clínica ou consultório?</h3>
                        <div>
                            <Estrelas valor={ 1 } valoratual={ pesquisa.avaliacaogeral } onClick={ () => setPesquisa( { ...pesquisa, avaliacaogeral: 1 } ) } />
                            <Estrelas valor={ 2 } valoratual={ pesquisa.avaliacaogeral } onClick={ () => setPesquisa( { ...pesquisa, avaliacaogeral: 2 } ) } />
                            <Estrelas valor={ 3 } valoratual={ pesquisa.avaliacaogeral } onClick={ () => setPesquisa( { ...pesquisa, avaliacaogeral: 3 } ) } />
                            <Estrelas valor={ 4 } valoratual={ pesquisa.avaliacaogeral } onClick={ () => setPesquisa( { ...pesquisa, avaliacaogeral: 4 } ) } />
                            <Estrelas valor={ 5 } valoratual={ pesquisa.avaliacaogeral } onClick={ () => setPesquisa( { ...pesquisa, avaliacaogeral: 5 } ) } />
                        </div>
                    </article>
                </Pergunta>
                <Pergunta>
                    <h2> Indicaria para um amigo? </h2>
                    <article style={ { display: 'flex', justifyContent: 'center', } }>
                        <div style={ { width: '130px', display: 'flex' } }>
                            <InputRadio>
                                <label htmlFor="indicaSim">Sim</label>
                                <input
                                    id="indicaSim"
                                    type="radio"
                                    name="indica"
                                    onChange={ ( e ) => { setPesquisa( { ...pesquisa, indicaria: 1 } ); } }
                                    checked={ pesquisa.indicaria }
                                />
                                <span></span>
                            </InputRadio>
                            <InputRadio>
                                <label htmlFor="indicaNao">Não</label>
                                <input
                                    id="indicaNao"
                                    type="radio"
                                    name="indica"
                                    onChange={ ( e ) => { setPesquisa( { ...pesquisa, indicaria: 0 } ); } }
                                    checked={ !pesquisa.indicaria }
                                />
                                <span></span>
                            </InputRadio>
                        </div>
                    </article>
                </Pergunta>
                <Pergunta>
                    <h2> Críticas, sugestões e comentários </h2>
                    <article>
                        <TextArea value={ pesquisa.comentarios } onChange={ ( e ) => setPesquisa( { ...pesquisa, comentarios: e.target.value } ) }>

                        </TextArea>
                    </article>
                </Pergunta>
                <div style={ { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' } }>
                    <Reaptcha
                        sitekey="6LfrDqgZAAAAABATEykmT5tqdYVnvx0B7Fm3Ahj3"
                        onVerify={ ( value ) => setRecaptchaToken( value ) }
                        onExpire={ () => setRecaptchaToken( null ) }
                    />
                    <a data-tip data-for='btnHome' >
                        <ButtonPadraoPrimary disabled={ !recaptchaToken } onClick={ () => salvaPesquisa() }>Enviar Feedback</ButtonPadraoPrimary>
                    </a>
                    <ReactTooltip delayShow={ 300 } id='btnHome' place="bottom" type="dark" effect="solid">
                        { recaptchaToken ? <span>Enviar Feedback</span> : <span>Antes selecione o captcha de verificação (Não sou o robô)</span> }
                    </ReactTooltip>
                </div>
            </ContainerPerguntas>
        </Container>
    );
}

export default Avaliacao;
